define('viewmodels/configuration/BusinessUnit',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger', 'viewmodels/GeneralSettings'],
    function (ko, router, app, appsecurity, navigation, system, logger, ObjGeneralSettings) {

    var tableObj = false;
    var isEdit = false;
    var TotalConcat = '';
    var BuViewModel = {
        BUTitle: ko.observable("Business Unit"),
        attached: attached,
        activate: activate,
        detached: detached,
        logger: logger,
        appsecurity: appsecurity,
        ObjGeneralSettings: ObjGeneralSettings,
        BusinessDerivedList: ko.observable(),
        BusinessUnitsList: ko.observableArray(),
        SaveSortOrder: SaveSortOrder,
        Reorderlist: ko.observableArray(),
        UpFunctionality: UpFunctionality,
        CancelSortOrder: CancelSortOrder,
        DownFunctionality: DownFunctionality,
        columnno: ko.observable(0),
        popUpTitle: ko.observable(),
        savePopUpButton: savePopUpButton,
        cancelPopUpButton: cancelPopUpButton,
        addFunctionality: addFunctionality,
        ReorderModel: ReorderModel,
        reordersortorder: reordersortorder,
        editableBusinessUnit: ko.observable(),
        editFunctionality: editFunctionality,
        deleteFunctionality: deleteFunctionality,
        addPopUpCss: ko.observable(true),
        editPopUpCss: ko.observable(true),
        configuartionSaveState: ko.observable(false),
        ControlsAccess: ko.observable(false),
        RegionsList: ko.observableArray(),
        ReorderlistDup: ko.observable(),
        CountriesList: ko.observableArray(),   //countries list to be populated on region change event
        RegionChanged: RegionChanged,
        BusinessLevelList: ko.observableArray(),
        BusinessLevelValueList: ko.observableArray(),
        BusinessLevelTableValueList: ko.observableArray(),
        SelectedDrpDwnValue: ko.observable(),
        L1Value: ko.observable(),
        L2Value: ko.observable(),
        L3Value: ko.observable(),
        L4Value: ko.observable(),
        L5Value: ko.observable(),
        SetDateValue: ko.observable(),
        PageNumber: ko.observable(),
        AssessmentTypeList: ko.observableArray([]),
        AssessmentTypeListDup: ko.observableArray([]),
        SelectedAssessmentType: ko.observableArray([]),
        ValuesChanged: ko.observable(false),
        SubOrgMappingChange: SubOrgMappingChange,
        LocaleCheckFlag: ko.observable(false),
        BusinessLevels: ko.observableArray([]),
        ViewLevelFunctionality: ViewLevelFunctionality,
    };
    return BuViewModel;

    function test(newValue) {
        try {
            if (newValue == false && tableObj != undefined) {

                BuViewModel.configuartionSaveState(true);
                tableObj.draw(false);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: test() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    }
    // Region dropdown change event for populating countries dropdown
    function RegionChanged(data, event) {
        //;
        try {
            BuViewModel.CountriesList([]);
            var selected_regionID = event.currentTarget.value;
            for (i = 0 ; i < BuViewModel.RegionsList().length ; i++) {
                if (BuViewModel.RegionsList()[i].RegionId() == selected_regionID) {
                    BuViewModel.CountriesList(BuViewModel.RegionsList()[i].CountriesList());
                }
            }
        }
        catch (e) {
            var msg = 'Exception' + e + 'Source RegionChanged() in BusinessUnit.js';
            logger.logMessage(msg);
        }
    }
    function tableCallBack(val) {
        try {
            if (BuViewModel.configuartionSaveState()) {
                for (i = 1, j = ($('#businessUnitTable').find('tr').length) ; i < j; i++) {
                    var viewControl = $($($('#businessUnitTable').find('tr').get(i)).find('td').get(2)).find('a').get(0);
                    var editControl = $($($('#businessUnitTable').find('tr').get(i)).find('td').get(2)).find('a').get(1);
                    var deleteControl = $($($('#businessUnitTable').find('tr').get(i)).find('td').get(2)).find('a').get(2);
                    ko.cleanNode(viewControl);
                    ko.cleanNode(editControl);
                    ko.cleanNode(deleteControl);
                    ko.applyBindingsToNode(viewControl, { click: BuViewModel.ViewLevelFunctionality }, BuViewModel);
                    ko.applyBindingsToNode(editControl, { click: BuViewModel.editFunctionality, css: { 'disabled': (!BuViewModel.appsecurity.finalConfigurationSave()) } }, BuViewModel);
                    ko.applyBindingsToNode(deleteControl, { click: BuViewModel.deleteFunctionality, css: { 'disabled': (!BuViewModel.appsecurity.finalConfigurationSave()) } }, BuViewModel);

                }
            }
            else
                ko.applyBindingsToNode($('#businessUnitTable'));
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: tableCallBack() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    }

    function activate() {
        try {
            if (BuViewModel.ObjGeneralSettings === undefined || BuViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((BuViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || BuViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && BuViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                BuViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (BuViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || BuViewModel.ObjGeneralSettings.LocalizedTextList() == null || BuViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || BuViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || BuViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        BuViewModel.LocaleCheckFlag(false);
                    else
                        BuViewModel.LocaleCheckFlag(true);
                });
            } else
                BuViewModel.LocaleCheckFlag(true);

            BuViewModel.BUTitle((BuViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || BuViewModel.ObjGeneralSettings.LocalizedTextList() == null || BuViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || BuViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || BuViewModel.ObjGeneralSettings.LocalizedIndexList() == null || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    };

    function detached() {
        try {
            $($(document.getElementsByClassName('list-group-item')).get(3)).removeClass('active');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    };

    function attached() {
        try {
            GetAllAssessmentTypes();
            //GetConfigurationFreezeStatus();
            if (appsecurity.isConfigurationFreeze() === undefined) {
                appsecurity.GetConfigurationFreezeFlag().then(function () {
                    if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                        BuViewModel.ControlsAccess(true);
                    }
                    else {
                        BuViewModel.ControlsAccess(false);
                    }
                });
            }
            else if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                BuViewModel.ControlsAccess(true);
            }
            else {
                BuViewModel.ControlsAccess(false);
            }
            $($(document.getElementsByClassName('list-group-item')).get(3)).addClass('active');
            $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(4)).addClass('active');
            GetDerivedBusinessLevel().then(function () {
                GetAllBusinessUnitsWithLevels();
            });

            if (BuViewModel.ObjGeneralSettings === undefined || BuViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((BuViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || BuViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && BuViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                BuViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (BuViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || BuViewModel.ObjGeneralSettings.LocalizedTextList() == null || BuViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || BuViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || BuViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        BuViewModel.LocaleCheckFlag(false);
                    else
                        BuViewModel.LocaleCheckFlag(true);
                });
            } else 
                BuViewModel.LocaleCheckFlag(true);


            BuViewModel.BUTitle((BuViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || BuViewModel.ObjGeneralSettings.LocalizedTextList() == null || BuViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || BuViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || BuViewModel.ObjGeneralSettings.LocalizedIndexList() == null || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    };

    function GetConfigurationFreezeStatus() {
        try {
            $.ajax({
                url: "/api/Configuration/GetConfigurationFreezeStatus",
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call from GetConfigurationFreezeStatusByScreen() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if (appsecurity.WriteAccess())
                        jsonResult ? BuViewModel.ControlsAccess(false): BuViewModel.ControlsAccess(true);
                }
                else
                    logger.logError((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(BuViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from GetConfigurationFreezeStatusByScreen() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status === 401) {
                    app.showMessage((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetConfigurationFreezeStatusByScreen() method in BusinessUnit.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from GetConfigurationFreezeStatusByScreen() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }
    }


    function GetDerivedBusinessLevel() {
        try {
            return $.ajax({
                url: "/api/Configuration/GetDerivedBusinessLevel",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
              .success(ajaxSuccess)
              .fail(ajaxFail)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetDerivedBusinessLevel() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult.length ==0 ||  jsonResult[0].Incident_Description == null) {
                    var mappedBusinessDerived = $.map(jsonResult, function (result) {
                        return new BusinessDerivedModel(result);
                    });
                    BuViewModel.BusinessDerivedList(mappedBusinessDerived);
                    var DerivedNameHTML = '';
                    var DerivedNameHTML = '<span>' + BuViewModel.BusinessDerivedList()[0].BLevelDerivedName() + '</span>';
                    document.getElementById('ToAddDerivedName').innerHTML = DerivedNameHTML;
                }
                else {
                    if (jsonResult.length > 0) {
                        var msg = 'An error occurred.Please contact your Application Administrator.';
                        logger.logError(jsonResult[0].Incident_Description + " - " + msg, 'Error', system.getModuleId(BuViewModel), true);
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetDerivedBusinessLevel() method in BusinessUnit.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                if (error.status === 401) {
                    app.showMessage((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetDerivedBusinessLevel() method in BusinessUnit.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetDerivedBusinessLevel() method in BusinessUnit.js';
                logger.logMessage(msg);
            }
        };
    }
    function BusinessDerivedModel(item) {
        try {
            var self = this;
            self.BLevelDerivedName = ko.observable($('<div/>').html(item.DerivedLevel).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessDerivedModel() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    }
    function GetAllBusinessUnitsWithLevels() {
        try {
            var options = {
                url: "/api/Configuration/GetAllBusinessUnitsWithLevels",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            };
            getAllBusinessUnits(options);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllBusinessUnitsWithLevels() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    }

    function GetAllBusinessLevels(Source) {
        try {
            return $.ajax({
                url: "/api/Configuration/getAllDistinctBusinessLevels",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
        .success(ajaxSuccess)
        .fail(ajaxFail)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetAllBusinessLevels() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult.length > 0 && jsonResult[0].Incident_Description == null) {
                    var MappedBUModelList = $.map(jsonResult, function (result) {
                        return new BusinessLevelModel(result);
                    });
                    BuViewModel.BusinessLevelList(MappedBUModelList);
                    BuViewModel.BusinessLevelValueList([]);
                    var BLDropDownInPopUp = "";
                    $('#AddBusinessLevel').append(BLDropDownInPopUp);
                    for (var i = 0; i < BuViewModel.BusinessLevelList().length; i++) {
                        BuViewModel.BusinessLevelValueList(BuViewModel.BusinessLevelList()[i].BusinessLevelValueList());
                        BLDropDownInPopUp += '<div class="new-form-group col-xs-6 col-sm-6 col-md-6 col-lg-6 no-padding-right">';
                        BLDropDownInPopUp += '<label class="control-label">' + BuViewModel.BusinessLevelList()[i].BlName() + '</label>';
                        BLDropDownInPopUp += '<div class="">';
                        BLDropDownInPopUp += '<select id="BLDrpDown_' + i + '" class="form-control" data-bind="with: editableBusinessUnit  ,event: {change: $root.SubOrgMappingChange }">';
                        BLDropDownInPopUp += '<option value="" selected>Select</option>';
                        for (var k = 0; k < (BuViewModel.BusinessLevelList()[i].BusinessLevelValueList()).length; k++) {
                            BLDropDownInPopUp += '<option value="' + BuViewModel.BusinessLevelList()[i].BusinessLevelValueList()[k].BlvalueName() + '">' + BuViewModel.BusinessLevelList()[i].BusinessLevelValueList()[k].BlvalueName() + '</option>';
                        }
                        BLDropDownInPopUp += '</select>';
                        BLDropDownInPopUp += '</div>';
                        BLDropDownInPopUp += '</div>';
                    }

                    if (Source == 1) {

                        document.getElementById('AddBusinessLevel').innerHTML = BLDropDownInPopUp;
                        ko.cleanNode(document.getElementById('AddBusinessLevel'));
                        ko.applyBindings(BuViewModel, document.getElementById("AddBusinessLevel"));

                    }
                }
                else {
                    if (jsonResult.length > 0) {
                        var msg = 'An error occurred.Please contact your Application Administrator.';
                        logger.logError(jsonResult[0].Incident_Description + " - " + msg, 'Error', system.getModuleId(BuViewModel), true);
                    }
                }
            }

            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetAllBusinessLevels() method in BusinessUnit.js';
                logger.logMessage(msg);
            }
        };
        function ajaxFail(error, status) {
            try {
                if (error.status === 401) {
                           app.showMessage((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllBusinessLevels() method in BusinessUnit.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllBusinessLevels() method in BusinessUnit.js';
                logger.logMessage(msg);
            }
        };
    }

    //These below two are used when we populate the drop downs in the Add Business Unit Pop Up
    function BusinessLevelModel(item) {
        try {
            var self = this;
            self.Bulevel = ko.observable(item.Bulevel);
            self.BlName = ko.observable(item.BlName);
            var MappedBuLevelValueList = $.map(item.BuLevelValueList, function (result) {
                return new BuLevelValueListModel(result);
            });
            //
            self.BusinessLevelValueList = ko.observableArray(MappedBuLevelValueList);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessLevelModel() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    }

    function BuLevelValueListModel(item) {
        try {
            var self = this;
            self.BlvalueId = ko.observable(item.BlvalueId);
            self.BlvalueName = ko.observable(item.BlvalueName);
            self.ParentBuLevel = ko.observable(item.ParentBuLevel);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BuLevelValueListModel() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    }

    //Function to get all the Business Units from Db into the DataTables
    function getAllBusinessUnits(options) {
        //;
        try {
            $.ajax(options)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in getAllBusinessUnits() method in BusinessUnit.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            // ;
            try {
                if (jsonResult == null) {
                    logger.logError((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(BuViewModel), true);
                }
                else {

                    BuViewModel.columnno(0);
                    BuViewModel.ReorderlistDup([]);
                    BuViewModel.Reorderlist([]);
                    var mappedBusinessUnits = $.map(jsonResult, function (result) {
                        return new BusinessUnits(result);
                    });
                    var reorderBusinessunitlist = $.map(jsonResult, function (result) {
                        return new ReorderModel(result);
                    });
                    BuViewModel.columnno(0);
                    var list = $.map(jsonResult, function (result) {
                        return new ReorderModel(result);
                    });


                    BuViewModel.Reorderlist(reorderBusinessunitlist);

                    BuViewModel.ReorderlistDup(list);

                    BuViewModel.BusinessUnitsList([]);

                    GetAllBusinessLevels(0).then(function () {

                        var TableHTML = '';
                        var countLevels = 0;
                        TableHTML += '<th data-orderable="false" style="display:none">Business Unit Id</th>';
                        TableHTML += '<th data-orderable="true" site_name column-10><span>';
                        TableHTML += (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SortOrder') == -1) ? 'Sort Order' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SortOrder')].Name();
                        TableHTML += '</span></th>';

                        TableHTML += '<th data-orderable="true" site_name column-10><span>';
                        TableHTML += (BuViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || BuViewModel.ObjGeneralSettings.LocalizedTextList() == null || BuViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || BuViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || BuViewModel.ObjGeneralSettings.LocalizedIndexList() == null || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name();
                        TableHTML += '</span></th>';

                        TableHTML += '<th data-orderable="false" class="site_name column-10"><span>';
                        TableHTML += (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ShortName') == -1) ? 'Short Name' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ShortName')].Name();
                        TableHTML += '</span></th>';

                        TableHTML += '<th data-orderable="false" class="site_name column-10"><span>';
                        TableHTML += (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAssessmentDate') == -1) ? 'Risk Assessment Date' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAssessmentDate')].Name();
                        TableHTML += '</span></th>';

                        TableHTML += '<th data-orderable="true" site_name column-10><span>';
                        TableHTML += (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevel') == -1) ? 'Applicable Organizational Levels' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrgLevel')].Name();
                        TableHTML += '</span></th>';

                        //if (BuViewModel.BusinessLevelList().length <= 3) {
                        //    for (var i = 0; i < BuViewModel.BusinessLevelList().length; i++) {
                        //        TableHTML += '<th data-orderable="false" class="site_name" style="width:10% !Important">' + BuViewModel.BusinessLevelList()[i].BlName() + '</th>';
                        //        countLevels++;
                        //    }
                        //}

                        //for (var i = 0; i < BuViewModel.BusinessLevelList().length; i++) {
                        //    TableHTML += '<th data-orderable="false" class="site_name" style="width:10% !Important">' + BuViewModel.BusinessLevelList()[i].BlName() + '</th>';
                        //    countLevels++;
                        //}
                        TableHTML += '<th data-orderable="false" class="site_name column-10"><span>';
                        TableHTML +=  (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InScope') == -1) ? 'In Scope' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InScope')].Name() + '</span></th>';
                        TableHTML += '<th data-orderable="false" class="site_name column-10"><span>';
                        TableHTML += (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Comments') == -1) ? 'Comments' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Comments')].Name() + '</span></th>';
                        TableHTML += '<th data-orderable="false" class="site_name column-10"><span>';
                        TableHTML += (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssessmentTypeApplicability') == -1) ? 'Assessment Type Applicability' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssessmentTypeApplicability')].Name() + '</span></th>';
                        
                        TableHTML += '<th data-orderable="false" class="actions-1" data-bind="if: ($root.ControlsAccess())"><span>';
                        TableHTML += (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Actions') == -1) ? 'Actions' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Actions')].Name() + '</span></th>';
                        ko.applyBindingsToNode($('#DivToAddTable table thead tr').append(TableHTML), {}, BuViewModel);
                        if ($.fn.DataTable.isDataTable('#businessUnitTable')) {
                            $('#businessUnitTable').DataTable().destroy();

                            tableObj = $('#businessUnitTable').DataTable();
                            BuViewModel.PageNumber($('#businessUnitTable').DataTable().page.info().page)
                            tableObj.destroy();
                            $("#businessUnitTable tbody tr").remove();
                        }
                        BuViewModel.BusinessUnitsList(mappedBusinessUnits);
                        tableObj = $('#businessUnitTable').DataTable({
                            responsive: true,
                           // "ordering": false,
                            "bAutoWidth": false,
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bVisible": false,
                            },
                              
                            //{
                            //    "aTargets": [2],
                            //    "bSortable": false
                            //},
                            //{
                            //    "aTargets": [3],
                            //    "bSortable": false
                            //},
                                {
                                    "aTargets": [countLevels + 6],
                                    "bSortable": false,
                                    "mRender": function (data, type, full) {

                                        if (data == true || data == "true")
                                            return '<div><span class="text-center">' + ((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('YesKeyWord') == -1) ? 'Yes' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('YesKeyWord')].Name()) + '</span></div>';
                                        else
                                            return '<div><span class="text-center">' + ((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoKeyWord') == -1) ? 'No' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoKeyWord')].Name()) + '</span></div>';
                                    },
                                    "sClass": "text-center"
                                }
                                //, {
                                //    "aTargets": [countLevels + 7],
                                //    //"bSortable": false,
                                //    "sClass": "text-center",
                                //    "bVisible": BuViewModel.ControlsAccess(),

                                //    }
                            ],
                            fnDrawCallback: tableCallBack
                        });
                        var p = tableObj.page.info().page;
                        tableObj.order([[1, 'asc']]);
                        tableObj.page(p).draw(false);
                    })

                }

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in getAllBusinessUnits() method in BusinessUnit.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status === 401) {
                           app.showMessage((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getAllBusinessUnits() method in BusinessUnit.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in getAllBusinessUnits() method in BusinessUnit.js';
                logger.logMessage(msg);
            }
        };
    }

    //Function to Add a Business Unit
    function addBusinessUnit(data) {
        
        try {
       
            var selectedassessmetId = "";
            for (var i = 0; i < BuViewModel.SelectedAssessmentType().length; i++) {
                if (i == 0)
                    selectedassessmetId += selectedassessmetId + BuViewModel.SelectedAssessmentType()[i];
                else
                    selectedassessmetId += "|" + BuViewModel.SelectedAssessmentType()[i];
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/AddBusinessUnits",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify({
                    BusinessLevelsList: ($.map(BuViewModel.BusinessLevels(), function (item) {
                        return { BlValue: item.BlValue };
                    })),
                    BuShortName: data.BusinessUnit_ShortName(), BuName: data.BusinessUnit_Name(), BuAssessmentDate: data.BuAssessmentDate(),
                    Comments: data.Comments(), BuStatus: data.BusinessUnit_Status(), Applicability: selectedassessmetId
                })
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in addBusinessUnit() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            //;
            try {
                var Buname = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name();
                if (jsonResult == null) {
                    logger.logError((!SrViewModel.LocaleCheckFlag() || SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InvalidCommentCharsMessage') == -1) ? jsonResult.Comments + ' - An error occurred while saving Comments. Because Comment contain some invalid characters.' : SrViewModel.ObjGeneralSettings.LocalizedTextList()[SrViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InvalidCommentCharsMessage')].Name(), 'Error', system.getModuleId(SrViewModel), true);
                }
                else if (jsonResult.Flag == 1) {
                    //if (jsonResult.BuId != 0 && jsonResult.BuName != null && jsonResult.BuShortName != null && jsonResult.BuStatus != null) {
                    //    var newBusinessUnit = new BusinessUnits(jsonResult);
                        GetAllBusinessUnitsWithLevels();
                        var msg = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('addedsuccessfully') == -1) ? 'added successfully.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('addedsuccessfully')].Name();
                        logger.logSuccess(Buname + ' ' + msg, + ' ', 'Success', system.getModuleId(BuViewModel), true);
                    //}
                    //else {
                    //    logger.logError((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? jsonResult.Comments + ' - An error occurred. Please contact your Application Administrator.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(BuViewModel), true);
                    //}
                }
                else if (jsonResult.Flag == 0) {
                    var msg = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyexists') == -1) ? 'already exists.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyexists')].Name();
                    logger.logError(jsonResult.Comments + ' - ' + Buname + ' ' + msg, 'Error', system.getModuleId(BuViewModel), true);
                }
                else
                    logger.logError(jsonResult.Comments + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(BuViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in addBusinessUnit() method in BusinessUnit.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                               app.showMessage((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in addBusinessUnit() method in BusinessUnit.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxFail in addBusinessUnit() method in BusinessUnit.js';
                    logger.logMessage(msg);
                }
            };
        };

    function editBusinessUnit(data) {
        // ;
        try {
           
                var selectedassessmetId = "";
                for (var i = 0; i < BuViewModel.SelectedAssessmentType().length; i++) {
                    if (i == 0)
                        selectedassessmetId += selectedassessmetId + BuViewModel.SelectedAssessmentType()[i];
                    else
                        selectedassessmetId += "|" + BuViewModel.SelectedAssessmentType()[i];
                }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/UpdateBusinessUnit",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify({
                    BusinessLevelsList: ($.map(BuViewModel.BusinessLevels(), function (item) {
                        return { BlValue: item.BlValue };
                    })),
                    BuId: data.BusinessUnit_ID(),
                    BuShortName: data.BusinessUnit_ShortName(), BuName: data.BusinessUnit_Name(), BuAssessmentDate: data.BuAssessmentDate(),
                    Comments: data.Comments(), BuStatus: data.BusinessUnit_Status(), Applicability: selectedassessmetId
                })
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in editBusinessUnit() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(result, status) {
            // ;
            try {
                var Buname = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name();
                if (result != null && result.length >= 1)
                {
                    var code = result.slice(0, 1);
                    var inc = result.slice(2, 11);
                    if (result == '1') {

                        for (i = 0; i < BuViewModel.RegionsList().length; i++) {
                            if (BuViewModel.RegionsList()[i].RegionId() == data.RegionId()) {
                                data.BusinessUnit_Region(BuViewModel.RegionsList()[i].RegionName());
                                for (j = 0; j < BuViewModel.RegionsList()[i].CountriesList().length; j++) {
                                    if (BuViewModel.RegionsList()[i].CountriesList()[j].CountryId() == data.CountryId()) {
                                        data.BusinessUnit_Country(BuViewModel.RegionsList()[i].CountriesList()[j].CountryName());
                                    }
                                }
                            }
                        }
                        var msg = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('updatedsuccessfully') == -1) ? 'updated successfully.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('updatedsuccessfully')].Name();
                        logger.logSuccess(Buname + ' ' + msg, + ' ', 'Success', system.getModuleId(BuViewModel), true);
                        GetAllBusinessUnitsWithLevels();
                    }
                    else if (code == '0') {
                        var msg = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyexists') == -1) ? 'already exists.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyexists')].Name();
                        logger.logError(inc+ ' - ' + Buname + ' ' + msg, 'Error', system.getModuleId(BuViewModel), true);
                    }
                    else {
                        var msg = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name();
                        logger.logError(result + ' - ' + msg,  'Error', system.getModuleId(BuViewModel), true);
                    }
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in editBusinessUnit() method in BusinessUnit.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {

            try {
                if (error.status === 401) {
                           app.showMessage((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in editBusinessUnit() method in BusinessUnit.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in editBusinessUnit() method in BusinessUnit.js';
                logger.logMessage(msg);
            }
        }
    };

    function deleteBusinessUnit(data, event) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/DeleteBusinessUnit",
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: ko.toJSON({
                    BuId: data.BusinessUnit_ID()
                }),
                headers: headers,
                type: "POST"
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in deleteBusinessUnit() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(result, status) {
            try {
                var Buname = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name();
                if (result != null && result.length >= 1) {
                    var code = result.slice(0, 1);
                    var negative_code = result.slice(0, 2);
                    var inc = result.slice(2, 11);
                    var negative_inc = result.slice(3, 11);
                    if (result == "1") {
                        GetAllBusinessUnitsWithLevels();
                        var msg = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeletedSuccessfully') == -1) ? 'deleted successfully.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeletedSuccessfully')].Name();
                        logger.logSuccess(Buname + ' ' + msg, 'Success', system.getModuleId(BuViewModel), true);
                    }
                    else if (code == "0") {
                        var msg = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('doesnotexists') == -1) ? 'does not exists.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('doesnotexists')].Name();
                        logger.logWarning(inc + ' - ' + Buname + ' ' + msg, 'Warning', system.getModuleId(BuViewModel), true);
                    }
                    else if (negative_code == "-1") {
                        var msg = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteBUmessange') == -1) ? ' is used in the configurations. Please contact the administrator to delete it.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DeleteBUmessange')].Name();
                        logger.logWarning(negative_inc + ' - ' + Buname + ' ' + msg, 'Warning', system.getModuleId(BuViewModel), true)
                    }
                    else {
                        var msg = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name();
                        logger.logError(result + ' - ' + msg, 'Error', system.getModuleId(BuViewModel), true);
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in deleteBusinessUnit() method in BusinessUnit.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {

            try {
                if (error.status === 401) {
                           app.showMessage((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option === ((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in deleteBusinessUnit() method in BusinessUnit.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in deleteBusinessUnit() method in BusinessUnit.js';
                logger.logMessage(msg);
            }
        }
    };

    function fnTotalConcat(TotalConcat) {
        var i = 0;
        TotalConcat = TotalConcat.replace('null', '');
        while (i < TotalConcat.length) {
            if (TotalConcat.charAt(0) == '-') {
                TotalConcat = TotalConcat.substring(1);
            }
            if (TotalConcat.charAt(TotalConcat.length - 1) == '-') {
                TotalConcat = TotalConcat.substring(0, TotalConcat.length - 1);
            }

            i++;
        }
        return TotalConcat;
    }
    function reordersortorder() {
        try {
            BuViewModel.popUpTitle((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Re-Order') == -1) ? 'Re-Order' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Re-Order')].Name())
            $('#frmReordermodel').modal('show');
            $('#valErrorforResort').hide();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: reordersortorder() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    }
    function DownFunctionality(data, event) {
        try {
            $('#valErrorforResort').hide();
            for (var i = 0; i < BuViewModel.Reorderlist().length; i++) {
                if (data.BusinessUnit_ID() == BuViewModel.Reorderlist()[i].BusinessUnit_ID()) {
                    if (i == 0) {
                        $('#valErrorforResort').show();
                        document.getElementById('valErrorforResort').innerHTML = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CannotGoUp') == -1) ? 'This cannot go further up' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CannotGoUp')].Name();
                    }
                    else {
                        var x = BuViewModel.Reorderlist()[i].BusinessUnit_ID();
                        var y = BuViewModel.Reorderlist()[i].BusinessUnit_ShortName();

                        BuViewModel.Reorderlist()[i].BusinessUnit_ID(BuViewModel.Reorderlist()[i - 1].BusinessUnit_ID());
                        BuViewModel.Reorderlist()[i].BusinessUnit_ShortName(BuViewModel.Reorderlist()[i - 1].BusinessUnit_ShortName());

                        BuViewModel.Reorderlist()[i - 1].BusinessUnit_ID(x);
                        BuViewModel.Reorderlist()[i - 1].BusinessUnit_ShortName(y);
                        break;
                    }
                }

            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: addFunctionality() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    }
    function UpFunctionality(data, event) {
        try {
            $('#valErrorforResort').hide();
            for (var i = 0; i < BuViewModel.Reorderlist().length; i++) {

                if (data.BusinessUnit_ID() == BuViewModel.Reorderlist()[i].BusinessUnit_ID()) {
                    if (i == BuViewModel.Reorderlist().length - 1) {
                        $('#valErrorforResort').show();
                        document.getElementById('valErrorforResort').innerHTML = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CannotGoDown') == -1) ? 'This cannot go further down' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CannotGoDown')].Name();
                    }
                    else {
                        var x = BuViewModel.Reorderlist()[i].BusinessUnit_ID();
                        var y = BuViewModel.Reorderlist()[i].BusinessUnit_ShortName();

                        BuViewModel.Reorderlist()[i].BusinessUnit_ID(BuViewModel.Reorderlist()[i + 1].BusinessUnit_ID());
                        BuViewModel.Reorderlist()[i].BusinessUnit_ShortName(BuViewModel.Reorderlist()[i + 1].BusinessUnit_ShortName());

                        BuViewModel.Reorderlist()[i + 1].BusinessUnit_ID(x);
                        BuViewModel.Reorderlist()[i + 1].BusinessUnit_ShortName(y);
                        break;
                    }
                }
            }


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: addFunctionality() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    }
    //This method is fired when the Add Business Unit Pop-up is Loaded
    function addFunctionality() {
        try {
            var newBusinessUnit = new BusinessUnits({
                BuId: 999, BuShortName: "", BuName: "", BuStatus: "APP", BuAssessmentDate: ""
            });

            BuViewModel.editableBusinessUnit(newBusinessUnit);
            BuViewModel.popUpTitle((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name());

            BuViewModel.addPopUpCss(true);
            BuViewModel.editPopUpCss(false);
            GetAllBusinessLevels(1).then(function () {
                var ConcatL1 = '';
                var ConcatL2 = '';
                var ConcatL3 = '';
                var ConcatL4 = '';
                var ConcatL5 = '';
                BuViewModel.SelectedAssessmentType([]);
                $('#SurveyAssessmentApplicability').multiselect();
                $("#BuAssessmentDate").datepicker();
                $('#frmBusinessUnit').modal('show');
                setTimeout("$('#BusinessUnit_Name').focus();", 200);
                $('#frmBusinessUnit .modal-content').css({
                    'width': '120%',
                    'height': '120%'
                });
                isEdit = false;
            })


        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: addFunctionality() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
        };

        function ViewLevelFunctionality(data, event) {
            try {
                BuViewModel.popUpTitle(data.BusinessUnit_Name());
                $('#ViewBusinessLevel').html("");

                var BLDropDownInPopUp = "";
                $('#ViewBusinessLevel').append(BLDropDownInPopUp);
                for (var i = 0; i < BuViewModel.BusinessLevelList().length; i++) {
                    BLDropDownInPopUp += '<div class="new-form-group col-xs-6 col-sm-6 col-md-6 col-lg-6 no-padding-right">';
                    BLDropDownInPopUp += '<label class="control-label">' + BuViewModel.BusinessLevelList()[i].BlName() + '</label>';
                    BLDropDownInPopUp += '<div class="">';
                    BLDropDownInPopUp += '<p id="BLDrpDown_' + i + '" class="form-control">';
                    BLDropDownInPopUp += '<option value="' + data.BusinessLevels()[i].BlValue() + '">' + data.BusinessLevels()[i].BlValue() + '</option>';
                    BLDropDownInPopUp += '</p>';
                    BLDropDownInPopUp += '</div>';
                    BLDropDownInPopUp += '</div>';
                }
                document.getElementById('ViewBusinessLevel').innerHTML = BLDropDownInPopUp;
                ko.cleanNode(document.getElementById('ViewBusinessLevel'));
                $('#frmViewBLListMain').modal('show');
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ViewLevelFunctionality() method in BusinessUnit.js';
                logger.logMessage(msg);
            }
        };

    function editFunctionality(data, event) {

        try {
            if (!BuViewModel.configuartionSaveState()) {
                if (data.BusinessUnit_Status() == "APPLICABLE")
                    data.BusinessUnit_Status("APP");
                else if (data.BusinessUnit_Status() == "NOT-APPLICABLE")
                    data.BusinessUnit_Status("NA");
                var selectedRow = $(event.currentTarget).closest("tr").get(0);
                data.TargetRow(selectedRow._DT_RowIndex);


                var newObservable = new BusinessUnits({
                    BuId: data.BusinessUnit_ID(), BuShortName: data.BusinessUnit_ShortName(), BuName: data.BusinessUnit_Name(),
                    BusinessLevels: data.BusinessLevels(),
                    Comments: data.Comments(),
                    BuStatus: data.BusinessUnit_Status(), BuAssessmentDate: data.BuAssessmentDate(), 
                });

                newObservable.TargetRow(selectedRow._DT_RowIndex);
                BuViewModel.editableBusinessUnit(newObservable);
                GetDerivedBusinessLevel();
                BuViewModel.popUpTitle(BuViewModel.BusinessDerivedList()[0].BLevelDerivedName());
                BuViewModel.addPopUpCss(false);
                BuViewModel.editPopUpCss(true);
                BuViewModel.SelectedAssessmentType(data.AssessmentTypeList());
                $('#SurveyAssessmentApplicability').multiselect();
                GetAllBusinessLevels(1).then(function () {
                    for (i = 0; i < data.BusinessLevels().length; i++) {
                        $('#BLDrpDown_' + i + ' option').each(function () { this.selected = (this.text == data.BusinessLevels()[i].BlValue()); });
                    }
                })

                var currentDate = new Date(data.BuAssessmentDate());
                $("#BuAssessmentDate").datepicker();
                $("#BuAssessmentDate").datepicker("setDate", currentDate);

                $('#frmBusinessUnit').modal('show');
                $('#frmBusinessUnit').modal('show');
                isEdit = true;
                setTimeout("$('#BusinessUnit_Name').focus();", 200);
            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: editFunctionality() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    };

    function deleteFunctionality(data, event) {
        try {
            if (!BuViewModel.configuartionSaveState()) {
                app.showMessage((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SureToDelete') == -1) ? 'Are you sure you want to delete this' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SureToDelete')].Name() + ' ' + (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name() + '?', (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Delete') == -1) ? 'Delete' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Delete')].Name() + ' ' + (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name(), [(!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name, (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name])
                    .then(function (option) {
                        var confirmText = ((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()).toString();
                        if (option === confirmText) {
                            deleteBusinessUnit(data, event);
                        }
                    });
            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: deleteFunctionality() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    };
    //this method fires on click of cancel button
    function CancelSortOrder(data, event) {
        try {
            var MappedControlAreaSortMOdelDup = $.map(BuViewModel.ReorderlistDup(), function (item) {
                return new ReorderDupModel(item);

            })
            BuViewModel.Reorderlist([]);
            BuViewModel.Reorderlist(MappedControlAreaSortMOdelDup)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: Cancel sort order() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    }
    //This method is fired on click of "Save" button on the Pop-Up
    function SaveSortOrder(data, event) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/SaveSortOrder",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify($.map(BuViewModel.Reorderlist(), function (item) {
                    return { BuId: item.BusinessUnit_ID(), SortOrder: item.SortOrder() };
                }))
            })
                                       .success(ajaxSuccessOverall)
                                       .fail(ajaxFailOverall);

            function ajaxSuccessOverall(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult != 1) {
                            $('#frmReordermodel').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                            GetAllBusinessUnitsWithLevels();
                            logger.logSuccess((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SortOrderSaved') == -1) ? 'Sort Order saved successfully.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SortOrderSaved')].Name(), 'Success', system.getModuleId(BuViewModel), true);
                        }
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in savesortorder() method in Businessunit.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {
                    if (error.status === 401) {
                               app.showMessage((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, "Error in Edit Operation", false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name()).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in savesortorder() method in AMLInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in savesorterorder() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveSortOrder() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
        }

        function BLValueListModel(item) {
            try {
                var self = this;
                self.BlValue = $('#BLDrpDown_' + item).val();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RegionModel() method in BusinessUnit.js';
                logger.logMessage(msg);
            }
        }

    function savePopUpButton(data, event) {
        try {
            var Buname = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name();
            BuViewModel.BusinessLevels([]);

            for (var i = 0; i < BuViewModel.BusinessLevelList().length; i++) {
               
                BuViewModel.BusinessLevels().push( new BLValueListModel(i));
            }

           
            data.BusinessUnit_ShortName = ko.observable($('#BusinessUnit_ShortName').val());
            data.BuAssessmentDate = ko.observable($('#BuAssessmentDate').val());
            $('#valError').hide();
            var duplicateCheckName = 0;
            var duplicateCheckShortName = 0;
            var ErrorMsg = '';
            var Flag = 1; //1 - No Error, -1 - Error
            var regexp = /^([a-zA-Z0-9 _-]+)$/;
            if (data.BusinessUnit_Name().match(regexp)) {
                $('#valError').hide();
            }
            else if (data.BusinessUnit_ShortName().match(regexp)) {
                $('#valError').hide();
            }
            else {
                $('#valError').show();
                $('#valError').text('Please enter valid input.');
            }
            for (var i = 0, j = BuViewModel.BusinessUnitsList().length; i < j; i++) {
                if ((data.BusinessUnit_Name().toUpperCase() == BuViewModel.BusinessUnitsList()[i].BusinessUnit_Name().toUpperCase()) && (data.TargetRow() != i))
                    duplicateCheckName++;
            }
            for (var i = 0, j = BuViewModel.BusinessUnitsList().length; i < j; i++) {
                if ((data.BusinessUnit_ShortName().toUpperCase() == BuViewModel.BusinessUnitsList()[i].BusinessUnit_ShortName().toUpperCase()) && (data.TargetRow() != i))
                    duplicateCheckShortName++;
            }

            if (Flag == -1) {
                $('#valError').text(ErrorMsg);
            }
            else if (data.BusinessUnit_ShortName() == "") {
                $('#valError').show();
                var msg = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ShortNameRequired') == -1) ? 'short name is required.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ShortNameRequired')].Name();
                $('#valError').text(Buname + ' ' + msg);
            }
            else if (data.BusinessUnit_ShortName().length > 100) {

                $('#valError').show();
                var msg = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('shortname100chars') == -1) ? 'short name cannot exceed 100 characters.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('shortname100chars')].Name();
                $('#valError').text(Buname + ' ' + msg);
            }
            else if (data.BusinessUnit_Name() == "") {
                $('#valError').show();
                var msg = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('nameisreq') == -1) ? 'name is required.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('nameisreq')].Name();
                $('#valError').text(Buname + ' ' + msg);
            }
            else if (data.BusinessUnit_Name().length > 100) {

                $('#valError').show();
                var msg =(!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('name100chars') == -1) ? 'name cannot exceed 100 characters.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('name100chars')].Name();
                $('#valError').text(Buname + ' ' + msg);
            }
            else if (BuViewModel.SelectedAssessmentType().length == 0) {
                $('#valError').show();
                var msg =(!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('atleastOneAssessmenttype') == -1) ? 'Atleast one Assessment Type should be selected.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('atleastOneAssessmenttype')].Name();
                $('#valError').text(msg);
            }
            else if(data.BuAssessmentDate()=="")
            {

                $('#valError').show();
                var msg = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAssessmentDateRequired') == -1) ? 'Risk Assessment Date is required.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskAssessmentDateRequired')].Name();
                $('#valError').text(msg);
            }

            else {
                if (!isEdit) {
                    if (duplicateCheckName != 0) {
                        $('#valError').show();
                        var msg =  (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyexistsEnterDiff') == -1) ? 'already exists. Please enter a different' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyexistsEnterDiff')].Name();
                        $('#valError').text(data.BusinessUnit_Name() + ' ' + msg + ' ' + Buname ); //changed this line
                    }
                    else if (duplicateCheckShortName != 0) {
                        $('#valError').show();
                        var msg =  (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyexistsEnterDiff') == -1) ? 'already exists. Please enter a different' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyexistsEnterDiff')].Name();
                        $('#valError').text(data.BusinessUnit_ShortName() + ' ' + msg + ' ' + Buname );
                    }
                    else {
                        addBusinessUnit(data);
                        $('#frmBusinessUnit').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                    }
                }
                else {
                    if (duplicateCheckName != 0) {
                        $('#valError').show();
                        var msg = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyexistsEnterDiff') == -1) ? 'already exists. Please enter a different' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyexistsEnterDiff')].Name();
                        $('#valError').text(data.BusinessUnit_Name() + ' ' + msg + ' ' + Buname );// changed here also
                    }
                    else if (duplicateCheckShortName != 0) {
                        $('#valError').show();
                        var msg = (!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyexistsEnterDiff') == -1) ? 'already exists. Please enter a different' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('alreadyexistsEnterDiff')].Name();
                        $('#valError').text(data.BusinessUnit_ShortName() + ' ' + msg + ' ' + Buname );
                    }
                    else {
                        //;
                        editBusinessUnit(data);
                        $('#frmBusinessUnit').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                    }
                }
            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: savePopUpButton() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    };

    //This method is fired on click of "Cancel" button on the Pop-Up
    function cancelPopUpButton(data) {
        try {
            $('#frmBusinessUnit').modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: cancelPopUpButton() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    };

    //-----------------------------------------------------------------Model Definition Starts Here----------------------------------------------------------------------------
    function ReorderDupModel(item) {
        try {
            var self = this;
            self.BusinessUnit_ID = ko.observable(item.BusinessUnit_ID());
            self.SortOrder = ko.observable(item.SortOrder());
            self.BusinessUnit_ShortName = ko.observable($('<div/>').html(item.BusinessUnit_ShortName()).text());;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ReorderDupModel() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    }
    function ReorderModel(item) {
        var self = this;
        self.BusinessUnit_ID = ko.observable(item.BuId);
        self.SortOrder = ko.observable(BuViewModel.columnno() + 1);
        self.BusinessUnit_ShortName = ko.observable($('<div/>').html(item.BuShortName).text());
        BuViewModel.columnno(BuViewModel.columnno() + 1);
    }
    function BusinessUnits(item) {
        try {
            var self = this;
            self.TargetRow = ko.observable();
            self.BusinessUnit_ID = ko.observable(item.BuId);
            self.SortOrder = ko.observable($('<div/>').html(item.SortOrder).text());
            self.BusinessUnit_ShortName = ko.observable($('<div/>').html(item.BuShortName).text());
            self.BusinessUnit_Name = ko.observable($('<div/>').html(item.BuName).text());
            self.BuAssessmentDate = ko.observable($('<div/>').html(item.BuAssessmentDate).text());
            self.BusinessUnit_Division = ko.observable($('<div/>').html(item.BuDivision).text());
            self.BusinessUnit_Status = ko.observable($('<div/>').html(item.BuStatus).text());
            self.RegionId = ko.observable(item.BuRegionId);
            self.BusinessUnit_Country = ko.observable($('<div/>').html(item.BuCountry).text());
            self.CountryId = ko.observable($('<div/>').html(item.BuCountryId).text());
            self.BusinessUnit_Region = ko.observable($('<div/>').html(item.BuRegion).text());

            self.Comments = ko.observable($('<div/>').html(item.Comments).text());
            var shortcomments = ko.observable($('<div/>').html(item.Comments).text());
            if (shortcomments().length > 50) {
                self.shortcomments = shortcomments().substring(0, 50) + "...";
            }
            else {
                self.shortcomments = shortcomments();
            }
            self.AssessmentTypeList = ko.observable(item.AssessmentTypeList);

            var MappedBuLevelValueList = $.map(item.BusinessLevels, function (result) {
                return new BLValueModel(result);
            });
            
            self.BusinessLevels = ko.observableArray(MappedBuLevelValueList);
           
            self.Applicability = ko.observable(item.Applicability);
            self.Bulevel = ko.observable($('<div/>').html(item.Bulevel).text());
            self.BlName = ko.observable($('<div/>').html(item.BlName).text());
            self.BusinessUnit_Status_Yes = ko.computed(function () {
                return (self.BusinessUnit_Status() == "APPLICABLE" || self.BusinessUnit_Status() == "APP")
            }, BuViewModel);

            self.BU_BLApplicability = ko.observable($('<div/>').html(item.BLApplicability).text());
            self.TargetRow = ko.observable();


        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnits() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    };

        function BLValueModel(item) {
            try {
                var self = this;
                var value = "";
                if (typeof item.BlValue == 'string')
                    value = item.BlValue;
                else
                    value = item.BlValue();

                self.BlValue = ko.observable($('<div/>').html(value).text());
                
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RegionModel() method in BusinessUnit.js';
                logger.logMessage(msg);
            }
        }

    function RegionModel(item) {
        try {
            var self = this;
            self.RegionId = ko.observable(item.RegionId);
            self.RegionName = ko.observable($('<div/>').html(item.RegionName).text());
            var MappedCountries = $.map(item.CountriesList, function (result) {
                return new CountryModel(result);
            });
            self.CountriesList = ko.observableArray(MappedCountries);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RegionModel() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    }

    function CountryModel(item) {
        try {
            var self = this;
            self.CountryId = ko.observable($('<div/>').html(item.CountryId).text());
            self.CountryName = ko.observable($('<div/>').html(item.CountryName).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CountryModel() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    }

        // changes for the Assessment type drop down 

        function GetAllAssessmentTypes() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/GetAssessmentTypes",
                    type: "GET",
                    headers: headers

                })
                    .success(function (jsonResult, error) {
                        BuViewModel.AssessmentTypeList([]);
                        BuViewModel.AssessmentTypeListDup([]);
                        if (jsonResult != null && jsonResult[jsonResult.length - 1].AssessmentId != -1) {


                            var MappedAssessmentList = $.map(jsonResult, function (result) {
                                return new AssessmentListModel(result);
                            });
                            var MappedAssessmentListDup = $.map(jsonResult, function (result) {
                                return new AssessmentListModel(result);
                            });

                        }
                        else {
                            if (jsonResult.length > 0) {
                                var msg = 'An error occurred.Please contact your Application Administrator.';
                                logger.logError(jsonResult[jsonResult.length-1].Description + " - " + msg, 'Error', system.getModuleId(BuViewModel), true);
                            }
                        }
                        


                        BuViewModel.AssessmentTypeList(MappedAssessmentList);
                        BuViewModel.AssessmentTypeListDup(MappedAssessmentListDup);

                    })
                    .fail(function (error, status) {
                        logger.logError((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(BuViewModel), true);
                    });

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAllAssessmentTypes() method in BusinessUnit.js';
                logger.logMessage(msg);
            }
        }



        function AssessmentListModel(item) {
            try {
                var self = this;
                self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
                self.AssessmentName =  ko.observable(item.AssessmentName);
                self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
                self.Description = ko.observable($('<div/>').html(item.Description).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AssessmentListModel() method in BusinessUnit.js';
                logger.logMessage(msg);
            }
        }

        function SubOrgMappingChange() {
            try {
                BuViewModel.ValuesChanged(true);
                if (isEdit) {
                    $('#valError').show();
                    $('#valError').text((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('changingOrglSublevel') == -1) ? 'Changing the Organizational Sub Level mapping will delete any present weights for this ' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('changingOrglSublevel')].Name() + ' Business Unit ' + ((!BuViewModel.LocaleCheckFlag() || BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('acrossThisOrgLevel') == -1) ? 'across this Organizational Sub Level.' : BuViewModel.ObjGeneralSettings.LocalizedTextList()[BuViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('acrossThisOrgLevel')].Name()));
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubOrgMappingChange() method in BusinessUnit.js';
                logger.logMessage(msg);
            }
        }
    //-----------------------------------------------------------------Model Definition Starts Here----------------------------------------------------------------------------
});

